module.exports = __webpack_public_path__ + "static/media/questionStartup.c5ba8540.png";